<template>
  <div class="product-details-top">
    <LoadedComponent :loading="loading" />
    <div class="bg-light pb-5 mb-4" v-if="!loading">
      <nav aria-label="breadcrumb" class="breadcrumb-nav border-0 mb-0">
        <div class="container d-flex align-items-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/dashboard">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/presentation">Presentazioni</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Detail</li>
          </ol>
        </div>
        <!-- End .container -->
      </nav>
      <div class="container">
        <div class="product-details product-details-centered product-details-separator">
          <h1 class="product-title">{{ presentation.name }}</h1>
          <div class="row d-flex justify-content-center">
            <div v-if="permission.update_presentazioni || presentation.owner" class="m-2">
              <router-link :to="'/presentation/edit/' + presentation.slug" class="btn btn-primary btn-sm"><i
                  class="las la-edit"></i></router-link>
            </div>

            <div v-if="permission.delete_presentazioni || presentation.owner" class="m-2">
              <button type="button" class="btn btn-danger btn-sm" data-toggle="modal"
                data-target="#delete-presentation">
                <i class="las la-trash-alt"></i>
              </button>
            </div>
          </div>
          <!-- End .product-title -->
        </div>

        <div class="text-center bg-light row">
          <div class="col-md-3 text-center" v-for="attachment in presentation.attachments" :key="attachment.id">
            <figure class="product-media">
              <div v-if="attachment.type_file == 'mp4'">
                <video-component :options="getOptons(attachment.path)"></video-component>

                <p class="pt-2 text-center">
                  <strong>{{ attachment.name }} </strong>
                </p>

                <a :href="attachment.path" class="btn btn-link" target="_blank">Apri un altra scheda<i
                    class="las la-external-link-alt"></i></a>
              </div>


               <div v-else-if="attachment.type_file == 'pdf'">
                <div class="embed-responsive embed-responsive-16by9 center-block">
               <iframe
                class=" holds-the-iframe"
                :src="attachment.path"
                :filename="attachment.code_file+'.pdf'"
                width="100%" height="100%"
                type="application/pdf"
                download
              >
                allowfullscreen
            
                </iframe>
                </div>

                <p class="pt-2 text-center">
                  <strong>{{ attachment.name }} </strong>
                </p>

                <a :href="attachment.path" class="btn btn-link" target="_blank">Apri un altra scheda<i
                    class="las la-external-link-alt"></i></a>
              </div>

            </figure>
          </div>
        </div>
      </div>
      <!-- End .breadcrumb-nav -->
    </div>

    <div class="product-details product-details-centered product-details-separator">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul>


              <li v-if="presentation.anatomical_district != ''">
                <strong>Distretto anatomico: </strong>{{ presentation.anatomical_district }}
              </li>

              <li v-if="presentation.patology != ''">
                <strong>Patologia da: </strong>{{ presentation.patology }}
              </li>

              <li>
                <strong>Pubblicato da: </strong>{{ presentation.full_name }} il
                {{ presentation.publish_date }}
              </li>
            </ul>
          </div>
          <div class="product-details-tab">
            <div class="product-desc-content text-center">
              <h3>Descrizione Presentazione</h3>
              <p>{{ presentation.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="delete-presentation">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Elimina la presentazione</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
              id="delete-modal-close-presentation">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="m-4">
              <p>Sei sicuro/a di voler eliminare la presentazione?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" id="delete-modal-close-library" data-dismiss="modal" aria-label="Close">
              Annulla
            </button>
            <button type="button" class="btn btn-outline-primary" @click="deletePresentation">
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import router from "@/router";
import { useAuth } from "@/stores/auth.js";
import httpservices from "@/services/httpservices.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import $ from "jquery";
import VideoComponent from "@/components/VideoComponent.vue";
window.jQuery = $;
window.$ = $;
export default {
  name: "ShowPresentation",
  props: ["slug"],
  components: { LoadedComponent, VideoComponent },
  data() {
    return {
      presentation: [],
      permission: {},
      loading: true,
    };
  },
  mounted() {
    this.loadPresentation();
    this.loadPermission();
  },
  created() { },
  methods: {
    getOptons(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        preload: false,

        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    async loadPresentation() {
      httpauth
        .get("/presentations/show/" + this.slug)
        .then((response) => {
          this.presentation = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async loadPermission() {
      await httpservices
        .checkPermission(1, "presentazioni", "create_presentazioni")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deletePresentation() {
      httpauth
        .get("/presentations/delete/" + this.presentation.slug)
        .then((response) => {
          localStorage.setItem(
            "successMessagePresentation",
            response.data.message
          );
          $("#delete-modal-close-presentation").click();
          router.push("/presentation");
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
  },
};
</script>

<style scoped>
.holds-the-iframe {
  background:url("https://img.icons8.com/windows/96/spinner-frame-5.png") center center no-repeat;
}
</style>